export enum MenuButtonLabelOverflowBehavior {
    Ellipsis = "ellipsis",
    Middle = "middle"
}
